import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    fill: "none",
    height: "18",
    viewBox: "0 0 18 18",
    width: "18"
};
const _hoisted_2 = ["stroke-width"];
const _hoisted_3 = ["stroke-width"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'clear',
    props: {
        strokeWidth: { default: '2' }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": props.strokeWidth
                }, null, 8, _hoisted_2),
                _createElementVNode("path", {
                    d: "M12 6L6 12M6 6L12 12",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": props.strokeWidth
                }, null, 8, _hoisted_3)
            ]));
        };
    }
});
